import React from 'react';
import { formatText } from 'core/i18n';
import CREDIT_CARD_LIGHT_BASIC from 'assets/images/credit-card-light-basic.svg';
import CREDIT_CARD_LIGHT_VF from 'assets/images/credit-card-light-vf.svg';
import CREDIT_CARD_LIGHT_EH from 'assets/images/credit-card-light-eh.png';
import { CreditCardLightRequeriments } from './CreditCardLightRequeriments';
import './CreditCardLightHeader.scss';

const CreditCardLightHeader = ({ type }) => {
    const getCreditCardLightStyles = () => {
        const styles = {
            basic: {
                image: CREDIT_CARD_LIGHT_BASIC,
                label: 'initialInfoSection-descriptionLabel_basic',
                title: 'initialInfoSection-descriptionTitle_basic',
                conditions: 'initialAddInfoSection-pdfConditionsLinkLight_basic',
            },
            vf: {
                image: CREDIT_CARD_LIGHT_VF,
                label: 'initialInfoSection-descriptionLabel_vf',
                title: 'initialInfoSection-descriptionTitle_vf',
                conditions: 'initialAddInfoSection-pdfConditionsLinkLight_vf',
            },
            eh: {
                image: CREDIT_CARD_LIGHT_EH,
                label: 'initialInfoSection-descriptionLabel_eh',
                title: 'initialInfoSection-descriptionTitle_eh',
                conditions: 'initialAddInfoSection-pdfConditionsLinkLight_eh',
            },
        };
        return styles[type];
    };

    const { image, label, title, conditions } = getCreditCardLightStyles();

    return (
        <div className={`tc-light-header theme-${type}`}>
            <div className="tc-light-header-wrapper">
                <div className="tc-light-header-desc">
                    <div>
                        <img src={image} className={`tc-light-header-card-art`} />
                    </div>
                    <div className="tc-light-header-desc-wrapper">
                        <div className="tc-light-header-desc-label">{formatText(label)}</div>
                        <div className="tc-light-header-desc-title">{formatText(title)}</div>
                    </div>
                </div>
                <CreditCardLightRequeriments conditionsText={conditions} />
            </div>
        </div>
    );
};

export default CreditCardLightHeader;
